import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { authzContextAtom } from '../../../authorization/authzState';
import { canAccess } from '../../../authorization/canAccess';
import { ConstantActions } from '../../../Services/_actions/constant.actions';
import { QUICK_LINKS_CATALOG } from '../config/quickLinksCatalog';

export default function useQuickLinks() {
  const authz = useRecoilValue(authzContextAtom);
  const { userHasPermission } = ConstantActions();

  const quickLinks = useMemo(
    () => QUICK_LINKS_CATALOG.filter((link) => {
      if (authz.isFullAccess) {
        return true;
      }
      if (!authz.isAuthzV2Enabled) {
        if (link.legacyPermission) {
          return userHasPermission([link.legacyPermission]);
        }
        return true;
      }
      return canAccess(authz, link.access ?? null);
    }),
    [authz, userHasPermission]
  );

  return { quickLinks, isLoading: false };
}
